import AddNewPost from "./AddNewPost";

export default AddNewPost;
